import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import NewImage from './NewImage';

const statusOptions = [
    { value: "On Air", label: "On Air" },
    { value: "Off Air", label: "Off Air" }
];

const modeOptions = [
    { value: 'Allstar', label: 'Allstar' },
    { value: 'APRS', label: 'APRS' },
    { value: 'DMR', label: 'DMR' },
    { value: 'D-Star', label: 'D-Star' },
    { value: 'Echolink', label: 'Echolink' },
    { value: 'FM', label: 'FM' },
    { value: 'Fusion', label: 'Fusion' },
    { value: 'IRLP', label: 'IRLP' },
    { value: 'NXDN', label: 'NXDN' },
    { value: 'P25', label: 'P25' },
    { value: 'Winlink', label: 'Winlink' },
]

const DistrictSettings = ({ district, showSettings, setShowSettings, currentUser, socket }) => {

    const handleClose = () => {
        setShowSettings(false);
    }

    const [distClone, setDistClone] = useState(district);

    const handleSubmit = () => {
        let authToken = localStorage.getItem('auth_token');
        let userId = localStorage.getItem('_id') ? localStorage.getItem('_id') : "";
        socket.emit('district settings', { _id: userId, jwt: authToken, data: { ...distClone, status: distClone.status.value } });
        socket.on('district update', data => {
            window.location.reload(false);
        });
        handleClose();
    }

    return (
        <Dialog open={showSettings} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>{district.district} Settings</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <Autocomplete
                        options={statusOptions}
                        defaultValue={{ value: district.status, label: district.status }}
                        onChange={(e, value) => setDistClone({ ...distClone, status: value })}
                        renderInput={(params) => <TextField {...params} label="Status" />}
                    />
                    <Autocomplete
                        multiple
                        options={modeOptions}
                        defaultValue={distClone.modes}
                        onChange={(e, value) => setDistClone({ ...distClone, modes: value })}
                        renderInput={(params) => <TextField {...params} label="Modes" />}
                    />
                    <NewImage
                        currentUser={currentUser}
                        showButton={true}
                        socket={socket}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="contained" onClick={handleSubmit}>
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    )
};

export default DistrictSettings;
